module.exports = __webpack_public_path__ + "static/media/ic-airplane-plus.e24003de.svg";